<div class="banner-container container-fluid g-0" #bannerContainer>
  @if (showBanner) {
    <div #animatedBannerElement data-testid="merchandising-component" role="banner" class="internal-message"
      [ngClass]="colourClass" (animationend)="onAnimationEnd()">
      <div class="row justify-content-center">
        <div class="col-1 image-icon d-flex justify-content-end px-0">
          <span role="img" aria-label="banner-icon" [attr.title]="iconAlt"
          [style.background]="iconSrc"></span>
        </div>
        <div class="col-9 col-lg-auto">
          @if (bodyText) {
            <div class="body-text" [innerHtml]="bodyText | aaSafeHtml"></div>
          }
        </div>
        <div class="col-1 d-flex justify-content-start">
          <span role="img" aria-label="close button" class="close-button" (click)="onCloseClick()"
            (keyup.esc)="onCloseClick()"
          [ngClass]="colourClass===blackBackground ? 'white-close-button' : 'black-close-button'"></span>
        </div>
      </div>
    </div>
  }
</div>